import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = {
  class: "modal-header",
  id: "mau_modal_add_oganizacion_header"
}
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  id: "mau_modal_add_oganizacion_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-2" })
], -1)
const _hoisted_6 = {
  class: "scroll-y",
  id: "mau_modal_add_oganizacion_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#mau_modal_add_oganizacion_header",
  "data-kt-scroll-wrappers": "#mau_modal_add_oganizacion_scroll",
  "data-kt-scroll-offset": "200px"
}
const _hoisted_7 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_8 = { class: "row mb-6" }
const _hoisted_9 = { class: "col col-form-label fw-bold fs-6" }
const _hoisted_10 = { class: "col-lg-8 fv-row" }
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { class: "row mb-6" }
const _hoisted_14 = { class: "col col-form-label fw-bold fs-6" }
const _hoisted_15 = { class: "col-lg-8 fv-row" }
const _hoisted_16 = { class: "fv-plugins-message-container" }
const _hoisted_17 = { class: "fv-help-block" }
const _hoisted_18 = { class: "row mb-6" }
const _hoisted_19 = { class: "col col-form-label fw-bold fs-6" }
const _hoisted_20 = { class: "col-lg-8 fv-row" }
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { class: "row mb-6" }
const _hoisted_24 = { class: "col col-form-label fw-bold fs-6" }
const _hoisted_25 = { class: "col-lg-8 fv-row" }
const _hoisted_26 = { class: "fv-plugins-message-container" }
const _hoisted_27 = { class: "fv-help-block" }
const _hoisted_28 = { class: "modal-footer flex-center" }
const _hoisted_29 = {
  type: "reset",
  id: "mau_modal_add_oganizacion_cancel",
  class: "btn btn-light me-3",
  "data-bs-dismiss": "modal"
}
const _hoisted_30 = ["data-kt-indicator", "disabled"]
const _hoisted_31 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_32 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

import { useModal } from "@/composable/useModal";
import tratamientos from "@/core/data/tratamientos";
import { hideModal } from "@/core/helpers/dom";
import { FamiliasListadoModule } from "@/store/modules";
import Swal from "sweetalert2";
import { ErrorMessage, useField, useForm } from "vee-validate";
import { onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";
import * as Yup from "yup";

interface FormValues {
  tratamiento: string;
  nombre: string;
  apellidos: string;
  fechaNacimiento: Date;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const module = getModule(FamiliasListadoModule, store);
const { t } = useI18n();
const { modalRef, isShown } = useModal();

onMounted(() => {
  resetForm({
    values: {
      tratamiento: "",
      nombre: "",
      apellidos: "",
      fechaNacimiento: new Date(),
    },
  });
});
watch(isShown, (value) => {
  if (!value) return;

  resetForm({
    values: {
      tratamiento: "",
      nombre: "",
      apellidos: "",
      fechaNacimiento: new Date(),
    },
  });
});

const validationSchema = Yup.object({
  tratamiento: Yup.string()
    .required()
    .label(t("formularios.familiaDetalle.tratamiento.label")),
  nombre: Yup.string()
    .required()
    .label(t("formularios.familiaDetalle.nombre.label")),
  apellidos: Yup.string()
    .required()
    .label(t("formularios.familiaDetalle.apellidos.label")),
  fechaNacimiento: Yup.date()
    .required()
    .label(t("formularios.familiaDetalle.menor.fechaNacimiento.label")),
});
const { handleSubmit, resetForm, meta } = useForm<FormValues>({
  validationSchema,
});
const { value: tratamiento } = useField("tratamiento");
const { value: nombre } = useField("nombre");
const { value: apellidos } = useField("apellidos");
const { value: fechaNacimiento } = useField("fechaNacimiento");

const loading = ref(false);
const submit = handleSubmit(async (values) => {
  if (!module.familia?.comarcaId || !module.familia?.id) return;

  try {
    loading.value = true;
    await module.addMenor({
      comarcaId: module.familia?.comarcaId,
      familiaId: module.familia?.id,
      menor: values,
    });
    await module.fetchMenoresById({
      comarcaId: module.familia?.comarcaId,
      id: module.familia?.id,
    });

    await Swal.fire({
      text: t("dialogs.añadirMenor.success"),
      icon: "success",
      buttonsStyling: false,
      confirmButtonText: t("dialogs.okButton"),
      heightAuto: false,
      customClass: {
        confirmButton: "btn fw-semobold btn-light-primary",
      },
    });
    hideModal(modalRef.value);
  } catch (error) {
    Swal.fire({
      text: t("dialogs.añadirMenor.error"),
      icon: "error",
      buttonsStyling: false,
      confirmButtonText: t("dialogs.okButton"),
      customClass: {
        confirmButton: "btn btn-primary",
      },
    });
  } finally {
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: "mau_modal_add_menor",
    ref_key: "modalRef",
    ref: modalRef,
    tabindex: "-1",
    "aria-hidden": "true",
    "aria-modal": "true",
    "aria-label": "Crear Menor",
    role: "dialog"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("dialogs.añadirMenor.titulo")), 1),
          _hoisted_5
        ]),
        _createElementVNode("form", null, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("formularios.familiaDetalle.tratamiento.label")), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_el_select, {
                    name: "tratamiento",
                    class: "w-100",
                    modelValue: _unref(tratamiento),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(tratamiento) ? (tratamiento).value = $event : null))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tratamientos), (tratamiento, i) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: i,
                          label: tratamiento.text,
                          value: tratamiento.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_unref(ErrorMessage), { name: "tratamiento" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("formularios.familiaDetalle.nombre.label")), 1),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_el_input, {
                    type: "text",
                    name: "nombre",
                    placeholder: "Nombre",
                    modelValue: _unref(nombre),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(nombre) ? (nombre).value = $event : null))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_unref(ErrorMessage), { name: "nombre" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("formularios.familiaDetalle.apellidos.label")), 1),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_el_input, {
                    type: "text",
                    name: "apellidos",
                    placeholder: "Apellidos",
                    modelValue: _unref(apellidos),
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(apellidos) ? (apellidos).value = $event : null))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_unref(ErrorMessage), { name: "apellidos" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("formularios.familiaDetalle.menor.fechaNacimiento.label")), 1),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_el_date_picker, {
                    format: "DD/MM/YYYY",
                    name: "fechaNacimiento",
                    modelValue: _unref(fechaNacimiento),
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(fechaNacimiento) ? (fechaNacimiento).value = $event : null)),
                    type: "date",
                    class: "w-100"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_unref(ErrorMessage), { name: "fechaNacimiento" })
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("button", _hoisted_29, _toDisplayString(_ctx.$t("dialogs.cancelButton")), 1),
          _createElementVNode("button", {
            "data-kt-indicator": loading.value ? 'on' : null,
            class: "btn btn-lg btn-primary",
            type: "submit",
            disabled: !_unref(meta).valid,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(submit)()))
          }, [
            (!loading.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.$t("dialogs.add")), 1))
              : _createCommentVNode("", true),
            (loading.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                  _createTextVNode(_toDisplayString(_ctx.$t("dialogs.addLoading")) + " ", 1),
                  _hoisted_33
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_30)
        ])
      ])
    ])
  ], 512))
}
}

})